/* eslint-disable camelcase */
import type { Account, SiteAccount, OwnedAccount } from '@hotjar/account';
import { BaseTarget } from './BaseTarget';
import type { BaseAttributes } from './BaseTarget';

interface AccountTargetAttributes extends BaseAttributes {
  account_created?: number;
}

class AccountExperimentTarget extends BaseTarget {
  account: Account | SiteAccount | OwnedAccount;

  constructor(account: Account | SiteAccount | OwnedAccount) {
    const { id } = account;
    super({ id });
    this.account = account;
  }

  // FIXME: Consider using a static method.
  // eslint-disable-next-line class-methods-use-this
  get prefix(): string {
    return 'acc';
  }

  get attributes(): AccountTargetAttributes {
    return {
      account_created: this.account.created,
    };
  }

  validate(): boolean {
    return BaseTarget.prototype.validate.call(this) && this.account.created !== undefined;
  }
}

export { AccountExperimentTarget as AccountTarget };
